export default __webpack_public_path__ + "static/media/app-gallery.7d7ff66e.svg";